module.exports = __webpack_public_path__ + "img/606643333067842_image.jpg";